module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "piv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Copyright © 2005 by Gerald Morris")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("All rights reserved. For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com/popular-reading",
      "target": "_blank"
    }
  }, [_vm._v("hmhco.com")])]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_c('em', [_vm._v("The Library of Congress has cataloged the print edition as follows:")])]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Morris, Gerald, 1963–"), _c('br'), _vm._v("\nThe lioness and her knight / written by Gerald Morris."), _c('br'), _vm._v("\np. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("Summary: Headstrong sixteen-year-old Lady Luneta and her distant cousin, Sir Ywain, travel to Camelot and beyond finding more adventure than they hoped for until, with the help of a fool, Luneta discovers what she really wants from life.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("[1. Knights and knighthood—Fiction. 2. Adventure and adventurers—Fiction. 3. Self-actualization (Psychology)—Fiction. 4. Middle Ages—Fiction. 5. Great Britain—History—To 1066—Fiction. 6. Humorous stories.] I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("PZ7.M82785Kn 2005 [Fic]—dc22 2004015782")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("ISBN 978-0-618-50772-6 hardcover")]), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("ISBN 978-0-547-01485-2 paperback")]), _vm._v(" "), _c('div', {
    staticClass: "timebreak "
  }), _vm._v(" "), _c('p', {
    staticClass: "center "
  }, [_vm._v("eISBN 978-0-547-53000-0"), _c('br'), _vm._v("\nv3.0418")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 63
// module chunks = 0